<template>
    <div
        class="group flex h-full cursor-pointer flex-col items-center rounded-3xl border border-app bg-card px-6 py-8 text-center shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand-500/10">
        <!-- Circular photo with soft ring -->
        <div
            class="h-32 w-32 shrink-0 overflow-hidden rounded-full border-4 border-brand-500/20 bg-brand-500/10 flex items-center justify-center">
            <img v-if="speaker.photoUrl" :src="speaker.photoUrl" :alt="speaker.name"
                class="h-full w-full object-cover object-top" />
            <span v-else class="text-3xl font-black text-brand-500">{{ initials(speaker.name) }}</span>
        </div>

        <h3 class="text-header mt-5 text-lg font-extrabold leading-snug">{{ speaker.name }}</h3>

        <p v-if="speaker.role" class="mt-1 text-sm font-bold text-rose-600">{{ speaker.role }}</p>

        <p v-if="speaker.company" class="text-body/80 mt-3 text-sm leading-relaxed">{{ speaker.company }}</p>

        <p v-if="speaker.country" class="text-header mt-auto flex items-center gap-1.5 pt-4 text-sm font-bold">
            <MapPin class="h-4 w-4 text-rose-600" />
            {{ speaker.country }}
        </p>
    </div>
</template>

<script setup lang="ts">
import { MapPin } from 'lucide-vue-next';
import { EventSpeaker } from '~/types';
import { initials } from '../helpers';

defineProps<{ speaker: EventSpeaker }>();
</script>

<style scoped>
.bg-card {
    background-color: rgb(var(--core-card-bg));
}

.border-app {
    border-color: rgb(var(--core-app-border));
}

.text-header {
    color: rgb(var(--core-header-text));
}

.text-muted {
    color: rgb(var(--core-muted-text));
}
</style>
